import { Translate } from '@change-corgi/core-react/i18n';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import type { StarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

import { ShareVisualModalBody } from './components/ShareVisualModalBody';

type Context = 'starter_dashboard_grow_petition';
type Petition = StarterDashboardV2PageData['petition'];

export const useShareVisualModal = createModalHook<{ petition: Petition; context: Context }>({
	name: 'ShareVisualModal',
	heading: () => (
		<Flex>
			<Heading breakWord as="h1" size="h3" data-qa="share-visual-modal-heading">
				<Translate value="corgi.petition.starter_dashboard.shared.share_visuals.modal_heading" />
			</Heading>
		</Flex>
	),
	body: function ShareVisualModal({ options: { petition, context }, closeModal }) {
		return <ShareVisualModalBody petition={petition} context={context} closeModal={closeModal} />;
	},
	stylesOverrides: {
		width: 'calc(100% - 32px)',
		minWidth: [null, 644],
		maxWidth: [400, 688],
	},
});
